import React from 'react';
import { Button, ButtonProps } from 'antd';

import './style.less';

const DetailsButton: React.FC<ButtonProps> = (props) => (
  <Button className="details-button" {...props} />
);

export default DetailsButton;
